"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Bed, Users, Bath, Coffee, Wifi, Wind } from "lucide-react";
const cabinData = [{
  id: 1,
  title: "1 Modular, 3-bedroom",
  specs: [{
    icon: Bed,
    label: "3 Beds"
  }, {
    icon: Bath,
    label: "2 Baths"
  }, {
    icon: Users,
    label: "Sleeps 6"
  }],
  amenities: [{
    icon: Coffee,
    label: "Coffee Maker"
  }, {
    icon: Wifi,
    label: "High-Speed WiFi"
  }, {
    icon: Wind,
    label: "Climate Control"
  }],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539566/img/riverside_suite_interior.png",
  idClassName: "absolute inset-0 transition-transform duration-[1200ms] ease-out scale-100 !bg-[url(https://wildflyfishingnm.com/wp-content/uploads/2026/03/2A357FB5-448A-41F6-8649-FF695893E866_1_105_c.jpeg)]"
}];
export default function CabinDetails() {
  const {
    ref: section1Ref,
    isVisible: isSection1Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: section2Ref,
    isVisible: isSection2Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: section3Ref,
    isVisible: isSection3Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const sectionRefs = [section1Ref, section2Ref, section3Ref];
  const sectionVisibilities = [isSection1Visible, isSection2Visible, isSection3Visible];
  return <section id="cabin-details" className="bg-[var(--color-dark-background)] text-[var(--color-foreground-dark)] py-[var(--space-3xl)] overflow-hidden">
      <div className="container">
        {cabinData.map((cabin, index) => <div key={cabin.id} ref={sectionRefs[index]} data-index={index} className="grid lg:grid-cols-2 gap-[var(--space-2xl)] items-center mb-[var(--space-3xl)] last:mb-0">
            {}
            <div className="space-y-[var(--space-xl)]">
              <h2 className={`font-display text-4xl md:text-5xl font-bold transition-all duration-[var(--duration-slow)] ease-[var(--ease-out)] ${sectionVisibilities[index] ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
                {cabin.title}
              </h2>

              <div className={`space-y-[var(--space-md)] transition-all duration-[var(--duration-slow)] ease-[var(--ease-out)] delay-100 ${sectionVisibilities[index] ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
                <h3 className="text-lg font-semibold text-[var(--color-secondary)]">Specifications</h3>
                <div className="flex flex-wrap gap-[var(--space-lg)]">
                  {cabin.specs.map((spec, i) => <div key={i} data-index={i} className="flex items-center gap-[var(--space-sm)]">
                      <spec.icon className="size-5 text-[var(--color-secondary)]" strokeWidth={1.5} />
                      <span className="text-sm">{spec.label}</span>
                    </div>)}
                </div>
              </div>

              <div className={`space-y-[var(--space-md)] transition-all duration-[var(--duration-slow)] ease-[var(--ease-out)] delay-[200ms] ${sectionVisibilities[index] ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
                <h3 className="text-lg font-semibold text-[var(--color-secondary)]">Amenities</h3>
                <div className="space-y-[var(--space-sm)]">
                  {cabin.amenities.map((amenity, i) => <div key={i} data-index={i} className="flex items-center gap-[var(--space-sm)]">
                      <amenity.icon className="size-5 text-[var(--color-secondary)]" strokeWidth={1.5} />
                      <span className="text-sm">{amenity.label}</span>
                    </div>)}
                </div>
              </div>
            </div>

            {}
            <div className="relative h-[500px] lg:h-[600px] rounded-[var(--radius-lg)] overflow-hidden">
              <div className={`${cabin.idClassName || ""} absolute inset-0 transition-transform duration-[1200ms] ease-out ${sectionVisibilities[index] ? "scale-100" : "scale-110"}`} style={{
            backgroundImage: `url(${cabin.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center"
          }} />
              
              {}
              <svg className="absolute inset-0 w-full h-full pointer-events-none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <clipPath id={`water-mask-${cabin.id}`}>
                    <path d={`M 0,0 L ${sectionVisibilities[index] ? "100%" : "0"},0 L ${sectionVisibilities[index] ? "100%" : "0"},100% L 0,100% 
                         Q ${sectionVisibilities[index] ? "5%" : "0"},${sectionVisibilities[index] ? "95%" : "100%"} 
                         ${sectionVisibilities[index] ? "10%" : "0"},${sectionVisibilities[index] ? "90%" : "100%"} 
                         Q ${sectionVisibilities[index] ? "15%" : "0"},${sectionVisibilities[index] ? "92%" : "100%"} 
                         ${sectionVisibilities[index] ? "20%" : "0"},${sectionVisibilities[index] ? "88%" : "100%"} 
                         Q ${sectionVisibilities[index] ? "25%" : "0"},${sectionVisibilities[index] ? "86%" : "100%"} 
                         ${sectionVisibilities[index] ? "30%" : "0"},${sectionVisibilities[index] ? "90%" : "100%"} 
                         L 0,100% Z`} className="transition-all duration-[1200ms] ease-out" />
                  </clipPath>
                </defs>
                <rect x="0" y="0" width="100%" height="100%" clipPath={`url(#water-mask-${cabin.id})`} fill="transparent" />
              </svg>

              {}
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--color-dark-background)]/60 to-transparent pointer-events-none" />
            </div>
          </div>)}
      </div>
    </section>;
}